export default __webpack_public_path__ + "961fc52347543c81de01c24027eb08c3.png";